import { 
  getDraftPurchaseRequest, 
  getPurchaseRequestById, 
  getPurchaseRequestListings, 
  submitPurchaseRequest,
  updatePurchaseRequest,
  deletePurchaseRequestItem
} from '../../hub/purchaseRequest';
import { GetPurchaseRequestListingsParams } from '../../../../contract/dtos/purchaseRequest';
export const purchaseRequestMutations = {
  queries: {
    getDraft: (params: { branchId: string; componentId: string; tenantId: string }) => ({
      queryKey: ['purchaseRequest', 'draft', params],
      queryFn: () => getDraftPurchaseRequest(params.branchId, params.componentId, params.tenantId),
    }),

    getById: (params: { id: string; componentId: string; tenantId: string; branchId: string }) => ({
      queryKey: ['purchaseRequest', 'byId', params],
      queryFn: () => getPurchaseRequestById(params.id, params.componentId, params.tenantId, params.branchId),
    }),

    getListings: (params: GetPurchaseRequestListingsParams) => ({
      queryKey: ['purchaseRequest', 'listings', params],
      queryFn: () => getPurchaseRequestListings(params),
    }),
  },

  mutations: {
    submit: () => ({
      mutationFn: ({ id, componentId, tenantId, branchId }: { id: string; componentId: string; tenantId: string; branchId: string }) =>
        submitPurchaseRequest(id, componentId, tenantId, branchId),
    }),

    update: () => ({
      mutationFn: ({ branchId, componentId, tenantId, body }: { 
        branchId: string; 
        componentId: string; 
        tenantId: string; 
        body: any 
      }) => updatePurchaseRequest(branchId, componentId, tenantId, body),
    }),

    deleteItem: () => ({
      mutationFn: ({ branchId, itemId, componentId, tenantId }: { branchId: string; itemId: string; componentId: string; tenantId: string }) =>
        deletePurchaseRequestItem(branchId, itemId, componentId, tenantId),
    }),
  },
};
